import { Product, StudySetupInfo } from 'queries';
import { Offer, QuoteInformation } from '@app/api';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { SupportOfferBlock } from 'components';
import { useMemo } from 'react';
import { useFormikContext } from 'formik';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'center',
    flexWrap: 'wrap',
    flexDirection: 'column',
    gap: theme.marginBase * 3 + 'px',

    [theme.media.desktop]: {
      flexDirection: 'row',
    },
  },
  contacBannerContainer: {
    width: '100%',
  },
  contactCardContainer: {
    width: '348px',
  },
}));

interface Props {
  offers: Offer[];
  selectedOffers: Offer[];
}

export const SupportSection = ({ offers, selectedOffers }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const { values } = useFormikContext<Partial<QuoteInformation>>();

  const selectedProductBeforeSupportOffer = useMemo(() => {
    const offer = selectedOffers.find(
      (offer) => offer.id === values.targetingOfferId,
    );
    if (!offer) {
      return [];
    }
    return offer.products.map(({ product }) => product) as Product[];
  }, [values.targetingOfferId, selectedOffers]);

  if (!offers || offers.length === 0) {
    return null;
  }

  const orderedSupportOffers = [...offers];

  orderedSupportOffers.sort((a, b) => {
    const productA = a?.products[0]?.product;
    const productB = b?.products[0]?.product;
    const priceA = productA?.price || 0;
    const priceB = productB?.price || 0;
    if (priceA === 0) {
      return 1;
    }
    if (priceB === 0) {
      return -1;
    }
    return priceA - priceB;
  });

  return (
    <div className={classes.container}>
      {orderedSupportOffers.map((offer) => (
        <SupportOfferBlock
          key={offer.id}
          offer={offer}
          name="supportOfferId"
          alreadySelectedProducts={selectedProductBeforeSupportOffer}
          trackingName="Support Offer"
          noIllustration={orderedSupportOffers.length < 4}
        />
      ))}
    </div>
  );
};
